import { useEffect, useState } from 'react';
import { toast, type ToastItem } from '../lib/toast';

export function ToastViewport() {
  const [items, setItems] = useState<ToastItem[]>([]);

  useEffect(() => toast.subscribe(setItems), []);

  if (items.length === 0) return null;

  return (
    <div
      className="pointer-events-none fixed bottom-4 right-4 z-50 flex max-w-sm flex-col gap-2"
      aria-live="polite"
      aria-relevant="additions"
    >
      {items.map((t) => (
        <div
          key={t.id}
          role="status"
          className={`pointer-events-auto rounded-lg border px-4 py-3 text-sm shadow-lg ${
            t.type === 'error'
              ? 'border-wine-500/50 bg-ink-900 text-cream-50'
              : 'border-gold-600/40 bg-ink-900 text-cream-100'
          }`}
        >
          {t.message}
        </div>
      ))}
    </div>
  );
}
